import { SITE_KEY } from 'src/constants';

export const getRecaptchaToken = async action => {
  // Load script only if needed
  const grecaptcha = await new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve(window.grecaptcha);
    } else {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
      script.async = true;
      script.onload = () => resolve(window.grecaptcha);
      script.onerror = reject;
      document.body.appendChild(script);
    }
  });

  // Execute once per call to get a fresh token
  return new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(SITE_KEY, { action });
        resolve(token);
      } catch (err) {
        reject(err);
      }
    });
  });
};
